import { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import icon from "../../assets/static/images/secciones/contribuyente.png";
import { setLoading } from "../../redux/Loading/actions";
import { contribuyenteService } from "../../_services/contribuyente.service";
import { inmuebleService } from "../../_services/inmuebles.service";
import Swal from "sweetalert2";
import { misContribuyenteService } from "../../_services/misContribuyentes.service";
import { getInmuebles } from "../../redux/Sections/Inmuebles/actions";
import { useHistory } from "react-router-dom";
import { useUser } from "../../hooks/useUser";


const ShowContribuyente = ({ show, handleClose, contribuyente }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { loading } = useSelector(e => e.dashboard);
  const user = useUser();
  const [defaultValues, setDefaultValues] = useState();
  const [inmuebles, setInmuebles] = useState();

  const {
    register,
    reset,
  } = useForm();

  useEffect(() => {
    const getData = async () => {
      dispatch(setLoading(true));
      try {
        let response = await contribuyenteService.getContribuyente({ recurso: contribuyente.RECURSO, imponible: contribuyente.IMPONIBLE });

        if (response?.contribuyente) {
          let inmuebles = await inmuebleService.getInmuebles({ nombre: response.contribuyente.APYNOM?.trim() });

          setDefaultValues(response?.contribuyente);
          setInmuebles(inmuebles);
          dispatch(setLoading(false));
        }
        else {
          setDefaultValues("");
          dispatch(setLoading(false));
        }
      }
      catch (err) {
        setDefaultValues("");
        dispatch(setLoading(false));
      }
    };

    getData();

    return () => {
      setDefaultValues("");
    };

  }, [contribuyente]);


  useEffect(() => {
    reset(defaultValues);
  }, [defaultValues]);

  const handleSave = () => {
    Swal.fire({
      title: "¿Esta seguro de guardar el contribuyente?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "No",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        const newData = {
          apynom: defaultValues.APYNOM,
          dni: defaultValues.NRO_DOC,
          cuim: defaultValues.CUIM,
          calle: defaultValues.CALLE,
          nro: defaultValues.NRO,
          telefono: defaultValues.TELEFONOS,
          titulo: defaultValues.VINCULO_DESC,
          inmuebles: inmuebles.map((e) => { return { inmueble: e.NRO_INMUEBLE }; }),
        };

        let response = await misContribuyenteService.createContribuyente(newData);

        if (response.ok) {
          return Swal.fire({
            title: "Exito!",
            text: "Los datos es guardaron correctamente.",
            icon: "success",
            willClose: () => handleClose(),
          });
        }
        else {
          return Swal.fire(
            "Error!",
            "Ocurrio un error, intentelo nuevamente.",
            "error"
          );
        }
      }
    });
  };

  const handleClick = async (imponible, recurso) => {
    try {
      dispatch(setLoading(true));

      dispatch(getInmuebles({ inmueble: imponible, recurso }))
        .then(() => {
          dispatch(setLoading(false));
          handleClose();
          return history.push("inmuebles");
        })
        .catch(err => {
          console.log(err);
        });
    }
    catch (err) {
      console.log(err);
      dispatch(setLoading(false));
    }
  };

  return (
    <Modal
      animation={false}
      show={!loading && show}
      onHide={handleClose}
      size="xl"
      className="contribuyente-modal"
      backdrop="static"
    >
      <Modal.Header closeButton />
      <Modal.Body>

        <Form className="contribuyente-form">
          <Row style={{ marginBottom: 50 }}>
            <Col sm={12} md={6}>
              <div className="contribuyente-title">
                <img src={icon} alt="contribuyente" />
                <span>Datos del Contribuyente</span>
              </div>
            </Col>
          </Row>
          <Row className="pb-2">
            <Col sm={12} md={6}>
              <Form.Label className="mb-2" style={{ marginTop: 10 }}>
                Nombre
              </Form.Label>
              <Form.Control
                name="APYNOM"
                readOnly={true}
                {...register("APYNOM")}
              />
            </Col>
            <Col sm={12} md={6}>
              <Form.Label className="mb-2" style={{ marginTop: 10 }}>
                DNI
              </Form.Label>
              <Form.Control
                name="NRO_DOC"
                readOnly={true}
                {...register("NRO_DOC")}
              />
            </Col>
          </Row>

          <Row className="pb-2">
            <Col sm={12} md={6}>
              <Form.Label className="mb-2" style={{ marginTop: 10 }}>CUIM</Form.Label>
              <Form.Control
                name="CUIM"
                readOnly={true}
                {...register("CUIM")}
              />
            </Col>
            <Col sm={12} md={6}>
              <Form.Label className="mb-2" style={{ marginTop: 10 }}>Número de contribuyente</Form.Label>
              <Form.Control
                name="NRO_CONTRIB"
                readOnly={true}
                {...register("NRO_CONTRIB")}
              />
            </Col>
          </Row>

          <Row className="pb-2">
            <Col sm={12} md={6}>
              <Form.Label className="mb-2" style={{ marginTop: 10 }}>Calle</Form.Label>
              <Form.Control
                name="CALLE"
                readOnly={true}
                {...register("CALLE")}
              />
            </Col>
            <Col sm={12} md={6}>
              <Form.Label className="mb-2" style={{ marginTop: 10 }}>Número</Form.Label>
              <Form.Control
                name="NRO"
                readOnly={true}
                {...register("NRO")}
              />
            </Col>
          </Row>

          <Row className="pb-2">
            <Col sm={12} md={6}>
              <Form.Label className="mb-2" style={{ marginTop: 10 }}>Teléfono</Form.Label>
              <Form.Control
                name="TELEFONOS"
                readOnly={true}
                {...register("TELEFONOS")}
              />
            </Col>
            <Col sm={12} md={6}>
              <Form.Label className="mb-2" style={{ marginTop: 10 }}>Titulo(titular, poseedor, tenedor, responsables)</Form.Label>
              <Form.Control
                name="VINCULO_DESC"
                readOnly={true}
                {...register("VINCULO_DESC")}
              />
            </Col>
          </Row>

          <Row className="pt-3">
            <Col sm={12} md={12}>
              <div className="mb-3" style={{ fontSize: 16, fontWeight: 600 }}>Lista de inmuebles</div>
              <div>
                <ul>
                  {
                    inmuebles?.length ? (
                      inmuebles.map((e, i) => {
                        return (
                          <li className="mb-2" key={"inmueble" + i}>
                            <div onClick={() => handleClick(e.NRO_INMUEBLE, e.RECURSO)} className="link-custom" >{e.NRO_INMUEBLE}</div>
                          </li>
                        );
                      })
                    ) : ""
                  }
                </ul>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-end">
            {user.abogado === "A00" ? (
              <Col style={{ maxWidth: 300 }}>
                <Button
                  className="custom-button"
                  onClick={handleSave}
                >
                  <span className="ml-2">Guardar en Novedades</span>
                </Button>
              </Col>
            ) : null}
            <Col style={{ maxWidth: 140 }}>
              <Button
                className="danger-button ml-2"
                variant="danger"
                onClick={handleClose}
              >
                <span className="ml-2">Cancelar</span>
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
    </Modal>);
};


export default ShowContribuyente;
